import { useEffect, useState } from 'react';
import { useSnapshot } from 'valtio';

import Panel from '@cartwhl/ui/layout/Panel';

import {
  animationGenerationStore,
  historyStore,
  navigationStore,
  uiStore,
} from 'stores';

import GenerationHistory from './GenerationHistory';
import HistoryAccordion from './HistoryAccordion';
import PanelSearch from './PanelSearch';

export default function HistoryPanel({
  close,
  isOpen,
  enterTransitionDuration = 0,
  exitTransitionDuration = 0,
}: {
  close: () => void;
  isOpen?: boolean;
  enterTransitionDuration?: number;
  exitTransitionDuration?: number;
}) {
  const { searchTerm, searchResults } = useSnapshot(historyStore.state);
  const { jobData, currentAnimationNumber, finishedInBackground } = useSnapshot(
    animationGenerationStore.state,
  );
  const { subPanelKey } = useSnapshot(uiStore.state);
  const [isSearchBarActive, setSearchBarActive] = useState(false);

  const showSearchResults = searchTerm.length > 1;

  useEffect(() => {
    // TODO: Use a ref instead. Couln't get it to work with the complicated Input component...
    const input = document.getElementById('panel-search-input');
    if (!input) return;
    if (isSearchBarActive) {
      input.focus();
    } else {
      input.blur();
    }
  }, [isSearchBarActive]);

  return (
    <Panel
      title="History"
      closePanel={close}
      subPanelKey={subPanelKey}
      isOpen={isOpen}
      enterTransitionDuration={enterTransitionDuration}
      exitTransitionDuration={exitTransitionDuration}
      additionalButtons={
        <PanelSearch
          isSearchBarActive={isSearchBarActive}
          setSearchBarActive={setSearchBarActive}
          searchTerm={searchTerm}
          setSearchTerm={historyStore.setSearchTerm}
        />
      }
    >
      {showSearchResults && (
        <HistoryAccordion
          jobs={searchResults}
          currentJobId={jobData?.jobID}
          currentVariationId={currentAnimationNumber}
          onClick={async (jobID, variationID) => {
            navigationStore.navigate(
              `/home?jobID=${jobID}&animationNumber=${variationID}`,
            );
            animationGenerationStore.fetchJob(jobID, variationID);
          }}
          finishedInBackground={finishedInBackground}
        />
      )}
      <div className={`${showSearchResults ? 'hidden' : ''}`}>
        <GenerationHistory />
      </div>
    </Panel>
  );
}
